"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskySearchField = void 0;

const react_1 = __importDefault(require("react"));

const Search_1 = __importDefault(require("@mui/icons-material/Search"));

const SskyInputField_1 = __importDefault(require("../SskyInputField"));

const SskySearchField = props => {
  return react_1.default.createElement(SskyInputField_1.default, {
    id: props.id,
    fullWidth: props.fullWidth,
    value: props.value,
    placeholder: props.placeholder,
    disabled: props.disabled,
    error: props.error,
    type: 'search',
    onChange: props.onChange,
    startAdornment: react_1.default.createElement(Search_1.default, {
      color: 'action'
    }),
    dataTestId: props.dataTestId || `testId-${props.id}`
  });
};

exports.SskySearchField = SskySearchField;
SskySearchField.defaultProps = {
  error: false,
  fullWidth: false
};
exports.default = react_1.default.memo(SskySearchField);